import { SvgHttpView } from '@flatbiz/antd';
import { isHttpUri } from '@flatbiz/utils';
import { Badge } from 'antd';
import { Fragment } from 'react';

export const SiderBarIcon = (props: {
  iconImg?: string;
  iconImgActive?: string;
  colorActive?: string;
  textColor?: string;
  icon?: string;
}) => {
  const svgImg = props.iconImg || props.icon;
  if (svgImg) {
    const isSvg = !isHttpUri(svgImg) ? true : svgImg.endsWith('.svg');
    if (isSvg) {
      return (
        <Fragment>
          <div className="menu-icon-img">
            <SvgHttpView
              svgPath={svgImg}
              color={props.textColor}
              style={{ display: 'block' }}
              width={16}
              height={16}
            />
          </div>
          <div className="menu-icon-img-active">
            <SvgHttpView
              svgPath={svgImg}
              color={props.colorActive}
              style={{ display: 'block' }}
              width={16}
              height={16}
            />
          </div>
        </Fragment>
      );
    }
  }

  if (props.iconImg && props.iconImgActive) {
    return (
      <Fragment>
        <div className="menu-icon-img" style={{ backgroundImage: `url(${props.iconImg})` }} />
        <div className="menu-icon-img-active" style={{ backgroundImage: `url(${props.iconImgActive})` }} />
      </Fragment>
    );
  }
  return <div className="menu-icon-placeholder" />;
};

export const MenuIconView = (props: {
  iconImg?: string;
  iconImgActive?: string;
  colorActive?: string;
  textColor?: string;
  icon?: string;
  collapsed?: boolean;
  badgeCount?: number;
}) => {
  if (props.badgeCount) {
    if (props.collapsed) {
      return (
        <Badge dot className="collapsed-menu-icon-badge">
          <SiderBarIcon {...props} />
        </Badge>
      );
    }
  }
  return <SiderBarIcon {...props} />;
};

export const MenuNoChildrenTextView = (props: { name: string; collapsed?: boolean; badgeCount?: number }) => {
  if (props.collapsed) {
    if (props.badgeCount) {
      return (
        <Fragment>
          <Badge dot style={{ marginRight: 4 }}></Badge>
          {props.name}
        </Fragment>
      );
    }
  }
  return <Fragment>{props.name}</Fragment>;
};
